import { NavLink, Outlet, Link } from "react-router-dom";
import { Sun, PlusCircle, TrendingUp, Sparkles, User } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const TABS = [
  { to: "/today", label: "Today", icon: Sun, id: "today" },
  { to: "/checkin", label: "Check-in", icon: PlusCircle, id: "checkin" },
  { to: "/trends", label: "Trends", icon: TrendingUp, id: "trends" },
  { to: "/companion", label: "Companion", icon: Sparkles, id: "companion" },
  { to: "/me", label: "Me", icon: User, id: "me" },
];

export const Logo = ({ className = "" }) => (
  <span className={`font-display text-xl tracking-[0.18em] font-medium ${className}`}>CAMRYN</span>
);

export function AppShell() {
  const { user } = useAuth();
  return (
    <div className="grain min-h-screen relative">
      <header className="sticky top-0 z-30 bg-[#FBF9F5]/90 backdrop-blur-md border-b border-stone-200/60 pt-[env(safe-area-inset-top)]">
        <div className="max-w-5xl mx-auto px-5 h-14 flex items-center justify-between">
          <Link to="/today" data-testid="header-logo-link"><Logo /></Link>
          <nav className="hidden lg:flex items-center gap-1">
            {TABS.map((t) => (
              <NavLink key={t.id} to={t.to} data-testid={`desktop-nav-${t.id}`}
                className={({ isActive }) => `px-3.5 py-1.5 rounded-full text-sm chip ${isActive ? "bg-stone-900 text-stone-50" : "text-stone-600 hover:bg-stone-100"}`}>
                {t.label}
              </NavLink>
            ))}
          </nav>
          {user?.plan === "plus" ? (
            <span data-testid="plan-badge-plus" className="text-[11px] font-semibold tracking-wider uppercase px-2.5 py-1 rounded-full bg-[#5A3E4E] text-white">Plus</span>
          ) : (
            <Link to="/pricing" data-testid="header-upgrade-link" className="text-xs font-semibold px-3 py-1.5 rounded-full border border-[#C86D51] text-[#C86D51] hover:bg-[#C86D51] hover:text-white chip">Upgrade</Link>
          )}
        </div>
      </header>
      <main className="relative z-10 max-w-2xl lg:max-w-3xl mx-auto px-5 sm:px-6 pt-6 pb-28 lg:pb-16">
        <Outlet />
      </main>
      <nav className="mobile-tabbar lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white/90 backdrop-blur-md border-t border-stone-200/70 pb-[env(safe-area-inset-bottom)]">
        <div className="flex justify-around items-center h-16">
          {TABS.map((t) => (
            <NavLink key={t.id} to={t.to} data-testid={`nav-tab-${t.id}`}
              className={({ isActive }) => `flex flex-col items-center gap-1 min-w-[60px] text-[11px] font-medium chip ${isActive ? "text-[#C86D51]" : "text-stone-500"}`}>
              <t.icon className="h-5 w-5" strokeWidth={1.75} />
              {t.label}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
